import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "classroom page-wrap"
}
const _hoisted_2 = { style: {"font-size":"14px","margin":"5px 0 15px"} }
const _hoisted_3 = {
  key: 1,
  class: "sess-grid"
}
const _hoisted_4 = { class: "panel timer-panel" }
const _hoisted_5 = {
  key: 0,
  class: "timer-lbl"
}
const _hoisted_6 = {
  key: 1,
  class: "timer-lbl"
}
const _hoisted_7 = {
  key: 2,
  class: "timer-lbl"
}
const _hoisted_8 = { class: "timer" }
const _hoisted_9 = {
  key: 3,
  class: "timer-btns"
}
const _hoisted_10 = {
  key: 4,
  class: "timer-btns"
}
const _hoisted_11 = {
  key: 5,
  class: "timer-btns"
}
const _hoisted_12 = { class: "pill p-done" }
const _hoisted_13 = { class: "panel" }
const _hoisted_14 = { class: "bar" }
const _hoisted_15 = { class: "cl-processes" }
const _hoisted_16 = ["onUpdate:modelValue", "disabled"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "panel"
}
const _hoisted_19 = { style: {"padding":"26px 12px 26px","text-align":"center","font-size":"14px"} }
const _hoisted_20 = {
  key: 0,
  style: {"margin-bottom":"15px"}
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 1,
  class: "panel"
}
const _hoisted_23 = { class: "av" }
const _hoisted_24 = { class: "att-n" }
const _hoisted_25 = { style: {"color":"var(--dark-gray)"} }
const _hoisted_26 = { style: {"font-size":"12px"} }
const _hoisted_27 = { class: "att-t" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 0,
  style: {"margin-top":"15px"}
}
const _hoisted_31 = {
  key: 2,
  class: "panel"
}
const _hoisted_32 = { class: "av" }
const _hoisted_33 = { class: "att-n" }
const _hoisted_34 = { style: {"color":"var(--dark-gray)"} }
const _hoisted_35 = { style: {"font-size":"12px"} }
const _hoisted_36 = { class: "att-t" }
const _hoisted_37 = {
  key: 2,
  class: "tr-delete"
}
const _hoisted_38 = {
  key: 1,
  class: "error-msg-wrap"
}
const _hoisted_39 = { class: "form-wrapper slide-up" }
const _hoisted_40 = { class: "form-close" }
const _hoisted_41 = { style: {"max-height":"200px","overflow":"auto"} }
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = { style: {"font-weight":"600"} }
const _hoisted_44 = { style: {"font-size":"14px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_onsite_session = _resolveComponent("onsite-session")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!
  const _component_pdf_pop_up = _resolveComponent("pdf-pop-up")!

  return (_ctx.classroom)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[32] || (_cache[32] = _createElementVNode("div", { class: "page-bar" }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", { class: "page-bar-sub" }, "Work"),
            _createElementVNode("div", { class: "page-bar-main" }, "Training")
          ])
        ], -1)),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
        }, [
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              class: "back-link",
              to: "/classrooms"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, { icon: "leftarrow" }),
                _cache[15] || (_cache[15] = _createTextVNode("All Training", -1))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("h1", null, [
            _createTextVNode(_toDisplayString(_ctx.classroom.Name) + " ", 1),
            _createElementVNode("span", {
              class: _normalizeClass('tr-type ' + (_ctx.classroom.Type == 'On-site' ? 'onsite' : 'classroom'))
            }, [
              _createVNode(_component_svg_icon, {
                icon: _ctx.classroom.Type == 'On-site' ? 'wrench' : 'classroom'
              }, null, 8, ["icon"]),
              _createTextVNode(_toDisplayString(_ctx.classroom.Type == 'On-site' ? 'On-site' : 'Classroom'), 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.classroom.DateString), 1),
          (_ctx.classroom.Type == 'On-site')
            ? (_openBlock(), _createBlock(_component_onsite_session, {
                key: 0,
                "read-only": !_ctx.canManage,
                classroom: _ctx.classroom,
                "employees-all": _ctx.employeesAll,
                "process-options": _ctx.$store.state.allNodes
              }, null, 8, ["read-only", "classroom", "employees-all", "process-options"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_4, [
                    (_ctx.classroom.Status == 'Upcoming')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.canManage ? 'Select attendees to begin' : 'NOT STARTED YET'), 1))
                      : (_ctx.classroom.Status == 'In progress')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "SESSION RUNNING"))
                        : (_ctx.classroom.Status == 'Completed')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "FINAL TIME"))
                          : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.timeString), 1),
                    (_ctx.classroom.Status == 'Upcoming' && _ctx.canManage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("button", {
                            onClick: _cache[0] || (_cache[0] = () => { _ctx.showStart = true }),
                            class: "btn-lg"
                          }, [
                            _createVNode(_component_svg_icon, {
                              icon: "twousers",
                              style: {"width":"14px","height":"14px"}
                            }),
                            _cache[16] || (_cache[16] = _createTextVNode("Select attendees & start", -1))
                          ])
                        ]))
                      : (_ctx.classroom.Status == 'In progress' && _ctx.canManage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (_ctx.paused)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pauseResumeTimer('stop'))),
                                  class: "btn-lg btn-light"
                                }, [
                                  _createVNode(_component_svg_icon, {
                                    icon: "play2",
                                    style: {"width":"12px","height":"12px"}
                                  }),
                                  _cache[17] || (_cache[17] = _createTextVNode("Resume", -1))
                                ]))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pauseResumeTimer('start'))),
                                  class: "btn-lg btn-light"
                                }, [
                                  _createVNode(_component_svg_icon, {
                                    icon: "pause",
                                    style: {"width":"12px","height":"12px"}
                                  }),
                                  _cache[18] || (_cache[18] = _createTextVNode("Pause", -1))
                                ])),
                            _createElementVNode("button", {
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.endSession())),
                              class: "btn-lg btn-light"
                            }, [
                              _createVNode(_component_svg_icon, {
                                icon: "check3",
                                style: {"width":"14px","height":"14px"}
                              }),
                              _cache[19] || (_cache[19] = _createTextVNode("End Session", -1))
                            ])
                          ]))
                        : (_ctx.classroom.Status == 'Completed')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("span", _hoisted_12, [
                                _createVNode(_component_svg_icon, { icon: "check2" }),
                                _cache[20] || (_cache[20] = _createTextVNode("Session Complete", -1))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("h4", null, [
                      _cache[21] || (_cache[21] = _createTextVNode("Processes reviewed", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.numFinished) + "/" + _toDisplayString(_ctx.processes.length), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", {
                        style: _normalizeStyle('width:'+_ctx.finishedPercent)
                      }, null, 4)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processes, (p, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "checkbox-input",
                          key: i
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((p.finished) = $event),
                            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.checkReviewedProcesses(true))),
                            disabled: !_ctx.canManage,
                            style: _normalizeStyle(_ctx.classroom.Status != 'In progress' || !_ctx.canManage ? 'pointer-events:none' : '')
                          }, null, 44, _hoisted_16), [
                            [_vModelCheckbox, p.finished]
                          ]),
                          _createElementVNode("a", {
                            onClick: _withModifiers(($event: any) => (_ctx.viewProcessFn(p)), ["prevent"])
                          }, _toDisplayString(p.name), 9, _hoisted_17)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  (_ctx.classroom.Status == 'Upcoming')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _cache[24] || (_cache[24] = _createElementVNode("h4", null, "Attendees", -1)),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_svg_icon, {
                              icon: "twousers",
                              style: {"width":"48px","height":"48px"}
                            })
                          ]),
                          _cache[23] || (_cache[23] = _createElementVNode("div", { style: {"margin-bottom":"5px","font-size":"18px"} }, "No one selected yet.", -1)),
                          (_ctx.canManage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Pick who's in the room when you're ready to start."))
                            : _createCommentVNode("", true),
                          (_ctx.canManage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("button", {
                                  onClick: _cache[5] || (_cache[5] = () => { _ctx.showStart = true }),
                                  class: "btn-lg",
                                  style: {"margin":"0"}
                                }, [
                                  _createVNode(_component_svg_icon, {
                                    icon: "twousers",
                                    style: {"width":"14px","height":"14px"}
                                  }),
                                  _cache[22] || (_cache[22] = _createTextVNode("Select attendees", -1))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_ctx.classroom.Status == 'In progress')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _cache[26] || (_cache[26] = _createElementVNode("h4", null, "Attendees", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendeesList, (a, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: "att",
                              style: _normalizeStyle(a.paused ? 'opacity: .5' : '')
                            }, [
                              _createElementVNode("div", _hoisted_23, _toDisplayString(a.initials), 1),
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, _toDisplayString(a.name), 1),
                                _createElementVNode("div", _hoisted_26, _toDisplayString(a.jobTitle), 1)
                              ]),
                              _createElementVNode("span", _hoisted_27, _toDisplayString(a.timeString), 1),
                              (a.paused && _ctx.canManage)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.pauseResumeTimerAtt('stop', a)),
                                    style: _normalizeStyle(_ctx.paused ? 'pointer-events:none' : ''),
                                    class: "toggle"
                                  }, [
                                    _createVNode(_component_svg_icon, { icon: "minususer" })
                                  ], 12, _hoisted_28))
                                : (_ctx.canManage)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      style: _normalizeStyle(_ctx.paused ? 'pointer-events:none' : ''),
                                      onClick: ($event: any) => (_ctx.pauseResumeTimerAtt('start', a)),
                                      class: "toggle"
                                    }, [
                                      _createVNode(_component_svg_icon, { icon: "adduser" })
                                    ], 12, _hoisted_29))
                                  : _createCommentVNode("", true)
                            ], 4))
                          }), 128)),
                          (_ctx.canManage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createElementVNode("a", {
                                  onClick: _cache[6] || (_cache[6] = _withModifiers(() => { _ctx.showStart = true }, ["prevent"])),
                                  class: "primary",
                                  style: {"text-decoration":"none!important"}
                                }, [
                                  _createVNode(_component_svg_icon, {
                                    icon: "adduser",
                                    style: {"width":"14px","height":"14px"}
                                  }),
                                  _cache[25] || (_cache[25] = _createTextVNode("  Edit attendees", -1))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_ctx.classroom.Status == 'Completed')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _cache[27] || (_cache[27] = _createElementVNode("h4", null, "Attendees", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendeesList, (a, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: "att"
                              }, [
                                _createElementVNode("div", _hoisted_32, _toDisplayString(a.initials), 1),
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, _toDisplayString(a.name), 1),
                                  _createElementVNode("div", _hoisted_35, _toDisplayString(a.jobTitle), 1)
                                ]),
                                _createElementVNode("span", _hoisted_36, _toDisplayString(a.timeString), 1)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                ])
              ])),
          (_ctx.classroom.CanDelete)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("a", {
                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.showConfirmDelete = true), ["prevent"]))
                }, "Delete Training")
              ]))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.showConfirmDelete)
          ? (_openBlock(), _createBlock(_component_confirm_delete, {
              key: 0,
              msg: `Delete '${_ctx.classroom.Name}'? Its attendees, times and sign-offs are deleted with it.`,
              onConfirm: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deleteClassroom())),
              onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showConfirmDelete = false))
            }, null, 8, ["msg"]))
          : _createCommentVNode("", true),
        (_ctx.showStart)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "form-close-x",
                    title: "Close",
                    onClick: _cache[10] || (_cache[10] = () => { _ctx.showStart = false })
                  }, "×")
                ]),
                _cache[31] || (_cache[31] = _createElementVNode("h3", null, "Who's in the room?", -1)),
                _createElementVNode("div", null, [
                  _cache[28] || (_cache[28] = _createTextVNode("Select everyone attending ", -1)),
                  _createElementVNode("b", null, _toDisplayString(_ctx.classroom.Name) + ".", 1),
                  _cache[29] || (_cache[29] = _createTextVNode(" Time is recorded against each person you pick.", -1))
                ]),
                _withDirectives(_createElementVNode("input", {
                  style: {"margin-top":"15px"},
                  type: "text",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.employeeSearchQ) = $event)),
                  onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.filterEmployees())),
                  placeholder: "Search employees"
                }, null, 544), [
                  [_vModelText, _ctx.employeeSearchQ]
                ]),
                _createElementVNode("div", _hoisted_41, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (e, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      style: {"margin-bottom":"5px"},
                      class: "checkbox-input"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((e.checked) = $event)
                      }, null, 8, _hoisted_42), [
                        [_vModelCheckbox, e.checked]
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_43, _toDisplayString(e.Name) + " · ", 1),
                        _createElementVNode("span", _hoisted_44, _toDisplayString(e.SeatTitle), 1)
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("button", {
                  style: {"margin-top":"25px","width":"100%"},
                  class: _normalizeClass(_ctx.disableButton ? 'btn-lg disable-button' : 'btn-lg'),
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.submitStart()))
                }, [
                  _createVNode(_component_svg_icon, {
                    icon: "play2",
                    style: {"width":"12px","height":"12px"}
                  }),
                  _cache[30] || (_cache[30] = _createTextVNode("Start Session", -1))
                ], 2)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.viewProcess)
          ? (_openBlock(), _createBlock(_component_pdf_pop_up, {
              key: 2,
              url: _ctx.processSlug,
              onClose: _cache[14] || (_cache[14] = () => _ctx.viewProcess = false)
            }, null, 8, ["url"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}